import { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import useWindowWidth from '@root/src/app/common/useWindowWidth';
import MobileMenu from './menuMobile';
import DesktopMenu from './menuDesktop';

export type MenuVariationI = {
  handleLogout: () => void;
  handleGoToDashboard: () => void;
  refreshOTP: () => void;
};

type MenuI = {
  handleLogout: () => void;
  refreshOTP: () => void;
};

const Menu = ({ handleLogout, refreshOTP }: MenuI): ReactElement => {
  const history = useHistory();
  const { isMobileView } = useWindowWidth();

  const handleGoToDashboard = () => {
    history.push('/dashboard');
  };

  return isMobileView ? (
    <MobileMenu
      handleGoToDashboard={handleGoToDashboard}
      handleLogout={handleLogout}
      refreshOTP={refreshOTP}
    />
  ) : (
    <DesktopMenu
      handleGoToDashboard={handleGoToDashboard}
      handleLogout={handleLogout}
      refreshOTP={refreshOTP}
    />
  );
};

export default Menu;
